import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import { callAPI } from './apiActions';
import { closeKYCSidePane } from './sidePaneActions';
import { showSnack } from './snackbarActions';
import { temporarilySetLevelIncreaseStatus, processingValidateUserRegistration, finishedValidateUserRegistration } from './kycActions';
import { setUserConfig } from './userActions';
var snackBarWarningSettings = {
  id: 'validateUserRegistrationError',
  timeout: 20000,
  type: 'warning'
};
var snackBarSuccessSettings = {
  id: 'validateUserRegistrationSuccess',
  timeout: 20000,
  type: 'success'
};
export var RECEIVE_KYC = 'RECEIVE_KYC';
export var receiveKYC = function receiveKYC(payload) {
  return {
    type: RECEIVE_KYC,
    payload: payload
  };
};
export var validateUserRegistrationIdentityMind = function validateUserRegistrationIdentityMind(payload) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var validateUserRegistrationPayload, setUserConfigPayload, response, result, showWarningSnack;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(processingValidateUserRegistration);
              validateUserRegistrationPayload = payload.validateUserRegistrationPayload, setUserConfigPayload = payload.setUserConfigPayload;
              _context.next = 4;
              return dispatch(callAPI('ValidateUserRegistration', validateUserRegistrationPayload));
            case 4:
              response = _context.sent;
              result = void 0;
              try {
                result = JSON.parse(response.result);
              } catch (error) {
                result = response.result;
              }
              showWarningSnack = function showWarningSnack(text) {
                dispatch(showSnack(Object.assign({}, snackBarWarningSettings, {
                  text: text
                })));
                dispatch(closeKYCSidePane());
              };
              if (result === false || result === null) {
                showWarningSnack("Validator isn't setup for the exchange. Please contact the exchange admin for help.");
              } else if (result === 'Unknown Validator Request' || result === 'Validator Not Connected') {
                showWarningSnack(result);
              } else if (result === 'Unable to validate') {
                showWarningSnack(result + '. Please contact the exchange admin for help.');
              } else if (result === 'Validator Call failed: The remote server returned an error: (500) Internal Server Error.') {
                showWarningSnack('There was a 500 Internal Server Error. Please contact the exchange admin for help.');
              } else if (result === 'Validator Call failed: Unable to connect to the remote server') {
                showWarningSnack('Our server-side verification service is currently unconfigured or down. Please contact the exchange admin for help.');
              } else if (result.ErrorMessage) {
                showWarningSnack('There was an error in processing your information. Be sure you are including all information required.');
              } else if (!result.ValidationAnswerData.IsAccepted && result.ValidationAnswerData.ApiError) {
                showWarningSnack(result.ValidationAnswerData.ApiErrorDescription || result.ValidationAnswerData.ApiError);
              } else if (result.ValidationAnswerData) {
                handleSuccess(result, setUserConfigPayload, dispatch);
              }
              return _context.abrupt('return', dispatch(finishedValidateUserRegistration));
            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
function handleSuccess(result, setUserConfigPayload, dispatch) {
  var snackbarText = void 0;
  if (result.ValidationAnswerData.IsAccepted) {
    snackbarText = 'Your information has been accepted and is currently under review. Your verification status will be updated within 24-48 hours.';
  } else if (!result.ValidationAnswerData.IsAccepted && result.ValidationAnswerData.NeedsManualReview) {
    snackbarText = 'Your information has been accepted and is currently under review.';
  } else {
    snackbarText = 'Your information has been accepted and is currently under review.';
  }
  dispatch(showSnack(Object.assign({}, snackBarSuccessSettings, {
    text: snackbarText
  })));
  dispatch(closeKYCSidePane());
}
export var validateUserRegistrationMitek = function validateUserRegistrationMitek(payload) {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      var response, result, rawData, kycPayload;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch(processingValidateUserRegistration);
              _context2.next = 3;
              return dispatch(callAPI('ValidateUserRegistration', payload));
            case 3:
              response = _context2.sent;
              result = void 0;
              rawData = void 0;
              try {
                result = JSON.parse(response.result);
                rawData = JSON.parse(result.ValidationAnswerData.RawData);
              } catch (error) {
                result = response.result;
              }
              if (result.ValidationAnswerData) {
                if (result.ValidationAnswerData.IsAccepted && result.ValidationAnswerData.RedirectUrl) {
                  kycPayload = {
                    urlParams: result.ValidationAnswerData.RedirectUrl
                  };
                  dispatch(receiveKYC(kycPayload));
                } else {
                  handleError(result, rawData, dispatch);
                }
              } else {
                dispatch(showSnack(Object.assign({}, snackBarWarningSettings, {
                  text: 'Something went wrong. Please contact the Exchange Admin'
                })));
                dispatch(closeKYCSidePane());
              }
              dispatch(finishedValidateUserRegistration);
            case 9:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var confirmMitek = function confirmMitek(setUserConfigPayload) {
  return function (dispatch) {
    dispatch(temporarilySetLevelIncreaseStatus({
      levelIncreaseStatus: 'underReview'
    }));
    // may not need submitUserConfig, but callback to setUserConfig from backend doesn't seem to be configured on apexqa(2)
    dispatch(setUserConfig(setUserConfigPayload.UserId, setUserConfigPayload.UserName, [{
      Key: 'levelIncreaseStatus',
      Value: 'underReview'
    }], false));
    dispatch(closeKYCSidePane());
  };
};
function handleError(result, rawData, dispatch) {
  var snackbarText = void 0;
  if (result.ValidationAnswerData.IsAccepted && !result.ValidationAnswerData.RedirectUrl) {
    snackbarText = 'Something went wrong. Please contact the Exchange Admin and alert them of this Error: "No redirect url (params)"';
  } else if (rawData.frd.includes('[Fired] No remaining queries')) {
    snackbarText = 'Something went wrong. Please contact the Exchange Admin and alert them of this Error: "[Fired] No remaining queries..."';
  } else {
    snackbarText = 'Something went wrong. Please contact the Exchange Admin';
  }
  dispatch(showSnack(Object.assign({}, snackBarWarningSettings, {
    text: snackbarText
  })));
  dispatch(closeKYCSidePane());
}